import React, { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { listProducts } from '../actions/productActions';
// import Product from '../components/product/Product';
// import Message from '../components/Message';
// import Loader from '../components/Loader';

const HomeScreenSimple = () => {
  // const dispatch = useDispatch();
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');
  // const [loading, setLoading] = useState(false);
  // const [error, setError] = useState(null);

  // Sample PPE/Safety product data as fallback
  const sampleProducts = useMemo(() => [
    {
      _id: '1',
      name: '3M Safety Goggles - Chemical Splash Protection',
      brand: '3M',
      image: '/images/products/3m-1621-chemical-splash-safety-goggles.jpg',
      category: 'Eye Protection',
      countInStock: 150,
      rating: 4.8,
      numReviews: 24,
      description: 'Professional grade safety goggles with anti-fog coating and chemical splash protection for laboratory and industrial use.'
    },
    {
      _id: '2',
      name: 'Nitrile Examination Gloves (Box of 100)',
      brand: 'Top Glove',
      image: '/images/products/nitrile-gloves.jpg',
      category: 'Hand Protection',
      countInStock: 500,
      rating: 4.6,
      numReviews: 89,
      description: 'Powder-free nitrile examination gloves offering superior chemical resistance and tactile sensitivity.'
    },
    {
      _id: '3',
      name: 'N95 Respirator Masks (Pack of 20)',
      brand: 'Honeywell',
      image: '/images/products/n95_mask.jpg',
      category: 'Respiratory Protection',
      countInStock: 200,
      rating: 4.7,
      numReviews: 156,
      description: 'NIOSH-approved N95 filtering facepiece respirators providing 95% filtration efficiency against airborne particles.'
    },
    {
      _id: '4',
      name: 'Steel Toe Safety Boots',
      brand: 'Caterpillar',
      image: '/images/products/steel-toe-boots.jpg',
      category: 'Foot Protection',
      countInStock: 75,
      rating: 4.5,
      numReviews: 43,
      description: 'Durable steel toe safety boots with slip-resistant sole and electrical hazard protection.'
    },
    {
      _id: '5',
      name: 'Hard Hat with Chin Strap',
      brand: 'MSA',
      image: '/images/products/hard_hat.jpg',
      category: 'Head Protection',
      countInStock: 120,
      rating: 4.4,
      numReviews: 67,
      description: 'ANSI-compliant hard hat with 4-point suspension system and adjustable chin strap for secure fit.'
    },
    {
      _id: '6',
      name: 'Disposable Lab Coats (Pack of 10)',
      brand: 'DuPont',
      image: '/images/products/Lab_Coat_Package_2400x2166.jpg',
      category: 'Disposables',
      countInStock: 30,
      rating: 4.3,
      numReviews: 15,
      description: 'Lightweight disposable lab coats with snap front closure and three pockets for laboratory use.'
    },
    {
      _id: '7',
      name: 'Noise Cancelling Ear Muffs',
      brand: 'Howard Leight',
      image: '/images/ear-muffs.jpg',
      category: 'Hearing Protection',
      countInStock: 85,
      rating: 4.6,
      numReviews: 32,
      description: 'Professional grade hearing protection with 30dB noise reduction rating for industrial environments.'
    },
    {
      _id: '8',
      name: 'Chemical Resistant Suit',
      brand: 'Lakeland',
      image: '/images/chemical-suit.jpg',
      category: 'Chemical Suits',
      countInStock: 25,
      rating: 4.8,
      numReviews: 18,
      description: 'Full body chemical protection suit with sealed seams and elastic wrists for hazardous material handling.'
    },
    {
      _id: '9',
      name: 'Fire Retardant Jacket',
      brand: 'Bulwark',
      image: '/images/fire-jacket.jpg',
      category: 'Fire Protection',
      countInStock: 40,
      rating: 4.7,
      numReviews: 14,
      description: 'Flame resistant jacket meeting NFPA 2112 standards for protection against flash fire hazards.'
    },
    {
      _id: '10',
      name: 'Safety Harness - Full Body',
      brand: 'Miller',
      image: '/images/safety-harness.jpg',
      category: 'Fall Protection',
      countInStock: 60,
      rating: 4.9,
      numReviews: 28,
      description: 'Full body safety harness with dorsal and frontal D-rings for fall arrest and positioning applications.'
    },
    {
      _id: '11',
      name: 'Cut Resistant Gloves Level 5',
      brand: 'HexArmor',
      image: '/images/cut-gloves.jpg',
      category: 'Hand Protection',
      countInStock: 180,
      rating: 4.5,
      numReviews: 76,
      description: 'ANSI Level 5 cut resistant gloves with superior grip and dexterity for handling sharp materials.'
    },
    {
      _id: '12',
      name: 'Face Shield with Anti-Fog Coating',
      brand: 'Uvex',
      image: '/images/face-shield.jpg',
      category: 'Eye Protection',
      countInStock: 95,
      rating: 4.4,
      numReviews: 41,
      description: 'Clear polycarbonate face shield with anti-fog coating providing full face protection from splashes.'
    }
  ], []);

  useEffect(() => {
    // Immediate loading without async operations
    const adminProducts = localStorage.getItem('adminProducts');
    if (adminProducts) {
      try {
        const parsedProducts = JSON.parse(adminProducts);
        if (parsedProducts.length > 0) {
          setProducts(parsedProducts);
          setFilteredProducts(parsedProducts);
          return;
        }
      } catch (error) {
        console.log('Error parsing admin products:', error);
      }
    }
    
    // Use sample products immediately
    setProducts(sampleProducts);
    setFilteredProducts(sampleProducts);
  }, [sampleProducts]);

  // Filter products based on search and category
  useEffect(() => {
    let filtered = products;
    
    if (searchTerm) {
      filtered = filtered.filter(product => 
        product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        product.category.toLowerCase().includes(searchTerm.toLowerCase()) ||
        product.brand?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        product.description?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    
    if (selectedCategory !== 'All') {
      filtered = filtered.filter(product => product.category === selectedCategory);
    }
    
    setFilteredProducts(filtered);
  }, [products, searchTerm, selectedCategory]);

  // Get unique categories
  const categories = ['All', ...new Set(products.map(p => p.category))];

  // Remove loading state entirely for instant display

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-br from-blue-600 via-blue-700 to-blue-900 text-white overflow-hidden">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
          <div className="text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              IKappal East Africa Limited
            </h1>
            <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
              Your trusted source for laboratory, industrial, and safety supplies in East Africa. 
              Professional PPE, safety equipment, and protective gear.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="#products" className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors text-center">
                Shop Now
              </a>
              <Link to="/about" className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-blue-600 transition-colors text-center">
                Learn More
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Error Message */}
      {/* {error && (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded">
            <p className="text-sm">{error}</p>
          </div>
        </div>
      )} */}

      {/* Search and Filter Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Find Your Safety Equipment</h2>
          <p className="text-lg text-gray-600">Search through our {products.length} professional PPE products</p>
        </div>
        
        {/* Search Bar */}
        <div className="max-w-2xl mx-auto mb-8">
          <div className="relative">
            <input
              type="text"
              placeholder="Search products, brands, categories..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full px-4 py-3 pl-12 pr-4 text-gray-900 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            />
            <svg className="absolute left-4 top-3.5 h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>
        </div>
        
        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-2 mb-8">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                selectedCategory === category
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {category} {category !== 'All' && `(${products.filter(p => p.category === category).length})`}
            </button>
          ))}
        </div>
        
        {/* Results Count */}
        <div className="text-center mb-6">
          <p className="text-gray-600">
            Showing {filteredProducts.length} of {products.length} products
            {searchTerm && ` for "${searchTerm}"`}
            {selectedCategory !== 'All' && ` in ${selectedCategory}`}
          </p>
        </div>
      </div>

      {/* Products Section */}
      <div id="products" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Safety Products</h2>
          <p className="text-lg text-gray-600">Professional PPE from trusted suppliers</p>
        </div>
        
        {filteredProducts.length === 0 ? (
          <div className="text-center py-12">
            <svg className="w-16 h-16 text-gray-300 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <p className="text-gray-500 text-lg mb-4">No products found</p>
            <p className="text-gray-400">Try adjusting your search or filter criteria</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filteredProducts.map((product) => (
            <div key={product._id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow">
              <div className="h-48 bg-gray-200 flex items-center justify-center">
                <span className="text-gray-500 text-4xl">🛡️</span>
              </div>
              <div className="p-4">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {product.name}
                </h3>
                <div className="flex items-center mb-2">
                  <div className="flex text-yellow-400">
                    {'★'.repeat(Math.floor(product.rating || 4))}
                    {'☆'.repeat(5 - Math.floor(product.rating || 4))}
                  </div>
                  <span className="text-sm text-gray-500 ml-2">
                    ({product.numReviews || 0} reviews)
                  </span>
                </div>
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <div className="w-6 h-6 bg-green-600 rounded-full flex items-center justify-center">
                      <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.097"/>
                      </svg>
                    </div>
                    <span className="text-sm font-semibold text-green-700">WhatsApp to Order</span>
                  </div>
                  <a
                    href={`https://wa.me/254710140890?text=Hello%20iKappalSafety!%0A%0AI'm%20interested%20in%20the%20following%20product:%0A%0A%F0%9F%93%A6%20Product:%20${encodeURIComponent(product.name)}%0A%F0%9F%8F%B7%20Brand:%20${encodeURIComponent(product.brand || 'Professional')}%0A%F0%9F%93%9D%20Category:%20${encodeURIComponent(product.category)}%0A%E2%AD%90%20Rating:%20${product.rating}/5%20(${product.numReviews}%20reviews)%0A%F0%9F%93%9B%20Description:%20${encodeURIComponent(product.description || 'Professional safety equipment')}%0A%0APlease%20provide:%0A%EF%B8%8F%20Current%20pricing%0A%EF%B8%8F%20Availability%20status%0A%EF%B8%8F%20Delivery%20options%0A%EF%B8%8F%20Bulk%20pricing%20(if%20applicable)%0A%0AThank%20you!`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 transition-colors"
                  >
                    Order Now
                  </a>
                </div>
                <div className="mt-2">
                  <span className={`text-sm ${product.countInStock > 0 ? 'text-green-600' : 'text-red-600'}`}>
                    {product.countInStock > 0 ? `${product.countInStock} in stock` : 'Out of stock'}
                  </span>
                </div>
              </div>
            </div>
          ))}
          </div>
        )}
      </div>

      {/* Features Section */}
      <div className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Why Choose IKappal?</h2>
            <p className="text-lg text-gray-600">We're committed to excellence in every aspect</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <span className="text-blue-600 text-2xl">🚚</span>
              </div>
              <h3 className="text-xl font-semibold mb-2">Fast Delivery</h3>
              <p className="text-gray-600">Quick and reliable delivery across East Africa with tracking</p>
            </div>
            <div className="text-center">
              <div className="bg-green-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <span className="text-green-600 text-2xl">✅</span>
              </div>
              <h3 className="text-xl font-semibold mb-2">Quality Products</h3>
              <p className="text-gray-600">Only the best products from trusted suppliers worldwide</p>
            </div>
            <div className="text-center">
              <div className="bg-purple-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <span className="text-purple-600 text-2xl">💬</span>
              </div>
              <h3 className="text-xl font-semibold mb-2">24/7 Support</h3>
              <p className="text-gray-600">Round-the-clock customer support for all your needs</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeScreenSimple;
